// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1dDNR","productName":"Table_productName__PGgcF"};